<template>
    <base-nav class="navbar-top "
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">

        </form>
        <ul class="navbar-nav align-items-center d-none d-md-flex" >
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0" >
                    <div class="media align-items-center" slot="title">
                        <!-- <i class="fa fa-bell fa-2x" aria-hidden="true"></i> -->
                        <i class="ni ni-bell-55 text-white lg4"></i>
                        <span class="badge badge-sm badge-warning border-white">{{notifications.count}}</span>
                    </div>
                    
                    <notification/>
                </base-dropdown>
            </li>
        </ul>&emsp;
        <ul class="navbar-nav align-items-center d-none d-md-flex" >
            <li class="nav-item dropdown">
<!--                <base-dropdown class="nav-link pr-0">-->
                    <div class="media align-items-center" slot="title">
                <span class="avatar avatar-sm rounded-circle">
                  <!-- <img alt="Image placeholder" src="img/theme/team-4-800x800.jpg"> -->
                  <v-avatar color="red">
                    <span class="white--text headline">{{acronym}}</span>
                  </v-avatar>
                </span>
                        <div class="media-body ml-2 d-none d-lg-block">
                            <span class="mb-0 text-sm  font-weight-bold" style="color: white">{{name}}</span>
                        </div>
                    </div>

<!--                       <right-side-bar-content/>-->

<!--                </base-dropdown>-->
            </li>
        </ul>
    </base-nav>
</template>
<script>
    import RightSideBarContent from '@/components/SidebarPlugin/RightSideBarContent'
    import Notification from '@/components/SidebarPlugin/Notification'
  export default {
      components: {
          RightSideBarContent,
          Notification
      },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
          acronym: localStorage.getItem('acronym'),
          name: localStorage.getItem('name')
      };
    },
    methods: {
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
    },
    
  };
</script>
<style>

</style>
